import { ReactNode } from "react";
import Card, { CardProps } from "@/shared/data-display/card";
import { twMerge } from "tailwind-merge";

export function Fieldset({
  children,
  title,
  cardProps,
}: {
  children: ReactNode;
  title: ReactNode;
  cardProps?: CardProps;
}) {
  return (
    <Card title={title} className="!mb-[24px]" {...cardProps}>
      <div className={twMerge("xl:pl-4")}>{children}</div>
    </Card>
  );
}
